<template>
  <div>
    <div class="mx-4 mt-4">
      <v-row v-if="selectedColumnHeaders && selectedColumnHeaders.length > 0">
        <v-col :cols="isMobile ? 12 : 3">
          <DatabaseEntryForm
            :selTable="table"
            :tblHeaders="selectedColumnHeaders"
            :foreignTablesArray="foreignTablesArray"
            :foreignKeysArray="foreignKeysArray"
            @data-saved="dataSaved"
          ></DatabaseEntryForm>
        </v-col>
        <v-col :cols="isMobile ? 12 : 9">
          <TableComponent
            :items="tableRowsData"
            :headers="selectedColumnHeaders"
            :foreignTablesArray="foreignTablesArray"
            :foreignKeysArray="foreignKeysArray"
            :title="title"
            :table="table"
            @item-deleted="itemDeleted"
          ></TableComponent>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import crudJs from "./crud";
import helpersJs from "@/plugins/helpers";
import DatabaseEntryForm from "baron-vue-data-entry-edit-form";
import TableComponent from "baron-vue-table-component";

export default {
  mounted() {
    this.setTableAndModel(this.$route.params.tableObj);
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  components: {
    TableComponent,
    DatabaseEntryForm,
  },
  data: () => ({
    title: null,
    table: null,
    foreignTablesArray: [],
    foreignKeysArray: [],
    selectedColumnHeaders: [],
    tableRowsData: [],
    foreignColumn: null,
  }),
  methods: {
    async setTableAndModel(tableObj) {
      this.table = tableObj.name;
      if (tableObj.ft && tableObj.ft.includes("&")) {
        this.foreignTablesArray = tableObj.ft.split("&");
        this.foreignKeysArray = tableObj.fk.split("&");
      } else if (tableObj.ft && !tableObj.ft.includes("&")) {
        this.foreignTablesArray = [tableObj.ft];
        this.foreignKeysArray = [tableObj.fk];
      } else {
        this.foreignTablesArray = [];
        this.foreignKeysArray = [];
      }

      this.title = `Manage ${crudJs.formatTableName(tableObj.name)}`;
      await this.getTableData(tableObj.name);
    },
    async getTableData(table) {
      this.$store.commit("setLoader", true);
      this.tableRowsData = await crudJs.getTableData(table);
      this.$store.commit("setLoader", false);
      if (this.tableRowsData.length < 1) {
        this.getTableColumnNames(table);
      } else {
        this.selectedColumnHeaders = crudJs.getTableColumnHeadersFromRowObject(
          this.tableRowsData[0],
          this.getCurrentUser.email
        );
      }
    },
    async getTableColumnNames(table) {
      this.$store.commit("setLoader", true);
      const allColumnNames = await crudJs.getTableColumnNames(table);

      this.selectedColumnHeaders = crudJs.formatColumnsArrayAsColumnHeaders(
        crudJs.filterStuffOutOfColumnNames(
          allColumnNames,
          this.getCurrentUser.email
        )
      );
      this.$store.commit("setLoader", false);
    },
    async dataSaved() {
      this.$store.commit("setLoader", true);
      await this.getTableData(this.table);
      this.$store.commit("setLoader", false);
    },
    async itemDeleted(selectedObjsArrayOrID) {
      this.tableRowsData = helpersJs.removeObjectFromArrayByObjectOrObjectID(
        this.tableRowsData,
        selectedObjsArrayOrID
      );
    },
  },
};
</script>
